import { useRef, useCallback } from "react";

const isDev = import.meta.env.DEV;

export function useTripleTap(onTripleTap: () => void) {
  const tapsRef = useRef<number[]>([]);
  const handleTap = useCallback(() => {
    if (!isDev) return;
    const now = Date.now();
    tapsRef.current.push(now);
    tapsRef.current = tapsRef.current.filter((t) => now - t < 1000);
    if (tapsRef.current.length >= 3) {
      tapsRef.current = [];
      onTripleTap();
    }
  }, [onTripleTap]);
  return handleTap;
}
